// extracted by mini-css-extract-plugin
module.exports = {"maxmobilewidth":"600px","mintabletwidth":"601px","maxtabletwidth":"960px","mindesktopwidth":"961px","create_account_form":"styles-module__create_account_form___1hI7b"};